import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { Glampoints } from 'components/icons/Glampoints';
import { Beauty } from 'components/icons/Beauty';
import { GlamClub } from 'components/icons/GlamClub';
import { Influencer } from 'components/icons/Influencer';
import { Glambox } from 'components/icons/Glambox';
import { Subscription } from 'components/icons/Subscription';
//import { SubscriberUtils } from "utils/SubscriberUtils";

class Eventos extends Component {
  /*componentDidMount() {
    const {
      person,
      history
    } = this.props;

    // Assinantes, Ex-Assinantes e Glampartners não precisam
    if (
      person.person 
      && SubscriberUtils.isOrWasSubscriber(person.person.personStatus)
    ) {
      history.push("/");
    }
  }*/

  render() {
    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Minha Glambox : Benefícios</title>
        </Helmet>

        <h1>Eventos</h1>
        <div className={'Eventos_page'}>
          <div className={'p-3 p-xl-5 desc intro level-2'}>
            <p>
              O evento <strong>B4A Beauty Meetup</strong> é a oportunidade perfeita para ter uma
              imersão no universo de beleza, conhecendo nossas marcas parceiras de perto, várias
              influenciadoras e muitas Glamgirls. Todos os meses celebramos a edição do mês e muitas
              novidades! Confira como fazer parte dessa festa abaixo:
            </p>
          </div>
        </div>

        <h3>
          <strong>Comunicado:</strong>
        </h3>
        <div className={'d-flex level-3 p-4'} style={{ background: '#fff' }}>
          <p>
            Devido as circunstâncias que estamos vivendo e{' '}
            <strong>como medida de proteção contra o vírus COVID-19,</strong> pausamos todos os
            eventos programados da Glambox. Para as assinantes que já compraram o ingresso do
            próximo evento, fiquem tranquilas que assim que a situação normalizar, continuaremos com
            nossa programação normalmente.
            <br />
            <br />
            Em caso de dúvidas, acesse o botão "Ajuda" localizado no canto inferior direito da tela.
          </p>
        </div>

        {/*<div className={"d-flex Eventos_page edition level-2"}>
            <div className={"cover"}></div>
            <img src={"https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_17542.png"} alt={""} />
          <div className={"p-3 p-xl-5 desc event"}>
            <h3>Sua chance de estar no evento da Glambox</h3>
            <p>
              A Magrechá e a Glambox querem saber o que você faz pra se manter saudável e equilibrada, além é claro dos chás Dia e Noite que a marca oferece para uma vida leve. Sortearemos 10 convites para o próximo evento de beleza da Glambox que acontece em São Paulo e 15 glampoints para todas a Glamgirls que participarem. Confira as regras:
              <br /><br />
              1. Poste no feed do seu Instagram uma foto do seu momento saudável utilizando a hashtag #GlamboxMagrechá que deve ficar disponível até 10/02.<br />
              2. Curta e comente o seu perfil na foto oficial do sorteio em nosso feed.<br />
              3. Siga os perfis @magrechaoficial e @glamboxbrasil.<br />
              4. Para ganhar os glampoints, conecte seu Insta com sua conta Glambox (menu de assinantes > minha glambox > dados pessoais > conecte seu Insta)
              <br />
              <br />
              Pronto! Você está participando. Não esqueça de deixar seu Instagram aberto no dia do sorteio 07/02 para conseguirmos verificar se está seguindo todas as regras.
              <br />
              <br />
              <small>
                *Entraremos em contato com as 10 vencedoras para passarmos as informações do evento.<br />
                *Sua foto precisa estar disponível até o dia 10/02 e seu Instagram precisa estar linkado com a sua conta Glambox para ganhar os glampoints. *Sortearemos os 10 convites no dia 10/02 e será pela ordem do sorteio, caso a sorteada não esteja dentro das regras sortearemos um novo perfil.
              </small>
              <br />
              <br />
              <a href="https://www.instagram.com/" target="_blank" className={"btn btn-md btn-light-lime"}>Quero postar</a>
            </p>
            <section><strong>Concurso válido até 18/10.</strong></section>
          </div>
        </div>*/}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  editions: state.editions,
  subscribers: state.subscribers,
});

Eventos = connect(mapStateToProps)(Eventos);

export { Eventos };
